// TODO: delete after localization will be done!!!
export {};

declare global {
  const $localize: (strings: TemplateStringsArray, ...expressions: unknown[]) => string;

  interface Window {
    $localize: (strings: TemplateStringsArray, ...expr: unknown[]) => string;
  }

  interface GlobalThis {
    $localize: typeof $localize;
  }
}

window.$localize = (strings: TemplateStringsArray, ...expressions: unknown[]): string => {
  const raw = strings.reduce((out, str, i) => out + str + (expressions[i] ?? ''), '');

  // @@id:translation
  const match = raw.match(/@@[^:]+:(.*)$/);
  return match ? match[1] : raw;
};

(globalThis as unknown as Window).$localize = (strings: TemplateStringsArray, ...expressions: unknown[]) => {
  const raw = strings.reduce((out, str, i) => out + str + (expressions[i] ?? ''), '');

  const match = raw.match(/@@[^:]+:(.*)$/);
  return match ? match[1] : raw;
};
